<div
        #banner
		[id]="bannerId"
        (click)="navigate()"
        (keyup.enter)="navigate()"
        class="hero-container-ar hero-container position-relative"
        [class.dpad-start]="dpadStart"
        dpadSelectable [scrollTo]="true"
        (focus)="focused.emit()">
	<div>
        <div class="image-wrapper hero">
            <div>
                <picture>
                    <source srcset="{{heroWeb + '?width=1400'}}">
                    <img
                         src="{{config.remoteConfig.loading_packshot}}" alt="Loading Image"/>
                </picture>
            </div>
            <div class="image-gradient"
                *ngIf="config.remoteConfig.hero_gradient_enabled && (logo || titleText)">
            </div>
        </div>

<!--		<img class="w-100 d-none d-lg-block" [src]="heroWeb">-->
	</div>
	<div class="hero-caption">
		<img [src]="logo" class="logo pb-2 pb-xl-3" />
		<p>{{titleText}}</p>
	</div>
</div>
